import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import DeleteOption from 'appSrc/components/Shards/DeleteOption';
import ListForm from './ListForm';
import style from './styles/style.module.css';


class EditListModal  extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    submit = ( response ) => {
        this.setState( { fetching: true } );
        var updates = { ...response };
        delete updates.list.tags;
        updates.list.interests = [ updates.list.interestId ];
        delete updates.list.interestId;

        // if rankedList is set to false, it's always fine to submit as false
        if (updates.list.rankedList === false) {
            updates.list.featured = false;
        }
        else {
            // rankedList is set to true;
            // if updates.list is already featured, do not set it again (this would put it at the top of the featured items)
            if (updates.list.featured) {
                updates.list.featured = undefined;
            }
            else {
                updates.list.featured = true;
            }
        }
        this.props.onSubmit( updates )
        .then( () => {
            this.setState( { fetching: false } );
            this.props.closeModal();
        } );
    }
    deleteList = () => {
        return this.props.onDelete && this.props.onDelete()
        .then( () => {
            this.setState( { fetching: false } );
            this.props.closeModal();
        } );
    }
    render() {
        const { modalName, modalProps, list } = this.props;
        let goodToGo = false;
        if ( modalName === 'editListModal' ) {
            goodToGo = true;
        }
        var initialValues = {
            ...list,
            interestId: ( list.interests || [ {interestid: null} ] ).map( interest => interest.interestid )[0],
            rankedList: !!list.featured,
        };
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Edit List"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Edit List</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <ListForm onSubmit={ this.submit } initialValues={ initialValues } />
                { this.state.fetching &&
                    <LoadingOverlay />
                }
                <div className={ style.footerControls }>
                    <DeleteOption
                    label='DELETE THIS LIST'
                    confirmLabel='ARE YOU SURE YOU WANT TO DELETE THIS LIST?'
                    yesLabel='DELETE'
                    deleteHandler={ this.deleteList } />
                </div>
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};

export default connect( mapStateToProps )( EditListModal );
